import type { CareersContent } from "../content/careers";
import { Editable } from "../edit";

// Admin-preview renderer for the Careers page: the hero is click-to-editable;
// the "where we're hiring" section and the application form are shown statically
// for context (the real application form — CV upload, validation, submission —
// is owned by the website code, not the CMS).
export function CareersSections({ content }: { content: CareersContent }) {
  const c = content;
  return (
    <>
      <section className="hero page-hero">
        <div className="hero-art" aria-hidden="true" style={{ opacity: 0.55 }}></div>
        <div className="wrap">
          <div className="hero-copy">
            <Editable as="p" className="eyebrow" path="hero.eyebrow" value={c.hero.eyebrow} />
            <Editable as="h1" path="hero.heading" value={c.hero.heading} />
            <Editable as="p" className="lede" path="hero.lede" value={c.hero.lede} singleLine={false} />
          </div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap">
          <div className="section-head">
            <p className="eyebrow">Where we're hiring</p>
            <h2>The teams we're putting together.</h2>
            <p className="lede">
              We don't list individual openings yet. Send a general application and tell us which team fits you best.
            </p>
          </div>
          <div className="segments">
            <div className="segment">
              <span className="tag">Product and engineering</span>
              <h3>Platform, AI and integrations</h3>
              <p>
                Messaging infrastructure on the WhatsApp Business Platform, Arabic-first conversational AI, and CRM and
                commerce connectors.
              </p>
            </div>
            <div className="segment">
              <span className="tag">Solutions and success</span>
              <h3>Regional hubs</h3>
              <p>
                Onboarding, WhatsApp Flows and template setup, quality management and customer success from hubs for the
                Middle East and North Africa, sub-Saharan Africa, and international markets.
              </p>
            </div>
            <div className="segment">
              <span className="tag">Commercial</span>
              <h3>Country and partner teams</h3>
              <p>Enterprise and government sales, agency partnerships and operator partnerships, led locally in each market.</p>
            </div>
            <div className="segment">
              <span className="tag">Central</span>
              <h3>Commercial management</h3>
              <p>
                Pricing, deal desk, revenue reporting, enablement and the relationship with Meta, plus finance, legal and
                operations.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap form-grid">
          <form onSubmit={(e) => e.preventDefault()}>
            <h2 style={{ fontSize: "var(--step-2)" }}>Apply</h2>
            <div className="row2">
              <div className="field">
                <label>Full name</label>
                <input disabled />
              </div>
              <div className="field">
                <label>Email</label>
                <input disabled />
              </div>
            </div>
            <div className="field">
              <label>Tell us about yourself</label>
              <textarea disabled rows={3} />
            </div>
            <div className="field">
              <label>CV (PDF, DOC, DOCX)</label>
              <input disabled placeholder="Choose a file" />
            </div>
            <div>
              <button className="btn btn-primary" type="button" disabled>
                Send application
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
}
